module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/managers/no-photo-9ed614b731eaa3d840061286a7fce779.png";